import DigitarCartao from "@pages/DigitarCartao/DigitarCartao";

export default DigitarCartao;
